module.exports = __webpack_public_path__ + "static/media/mo.44b9a0c4.svg";